module.exports = __webpack_public_path__ + "static/media/header-right.9fd26509.png";